module.exports = function (app, mod) {
  var games_menu = '';
  var league = null;
  league = app.modules.returnFirstRespondTo('leagues-for-arcade');
  for (var i = 0; i < mod.mods.length; i++) {
    var _league;
    var game_mod = mod.mods[i];
    var lid = app.crypto.hash(game_mod.returnName());
    if (!((_league = league) !== null && _league !== void 0 && _league.returnLeague(lid))) {
      lid = '';
    }
    if (game_mod.teaser == true) {
      games_menu += "\n       <div id=\"".concat(game_mod.name, "\" class=\"arcade-teaser arcade-teaser-install\" data-id=\"").concat(game_mod.name, "\" data-league=\"").concat(lid, "\">\n         <div class=\"arcade-teaser-image\"><img src=\"").concat(game_mod.img, "\" /></div>\n         <div class=\"arcade-teaser-title\"><span>").concat(game_mod.returnName(), "</span></div>\n         <div class=\"arcade-teaser-footer\"></div>\n       </div>\n\t\t\t");
    } else {
      games_menu += "\n       <div id=\"".concat(game_mod.name, "\" class=\"arcade-teaser\" data-id=\"").concat(game_mod.name, "\" data-league=\"").concat(lid, "\">\n         <div class=\"arcade-teaser-image\"><img src=\"").concat(game_mod.respondTo('arcade-games').image, "\" /></div>\n         <div class=\"arcade-teaser-title\"><span>").concat(game_mod.returnName(), "</span></div>\n         <div class=\"arcade-teaser-footer\"></div>\n       </div>\n\t\t\t");
    }
  }
  return games_menu;
};